module.exports = __webpack_public_path__ + "static/media/error.13121e36.svg";